import React from "react";
import { CheckCircle2, Clock, Star } from "lucide-react";
import { euro, workLabel } from "../../lib/format";

export default function ProposalPackageGroups({ cur, locked, quote, selectPackage, selections }) {
  return (
    <>
    {(quote.groups || []).map((g) => {
      const selectedId = selections[g.id]?.package || (g.packages.find((p) => p.default_selected) || g.packages[0] || {}).id;
      return (
        <div key={g.id} data-testid={`public-group-${g.id}`} className="mb-2">
          <h2 className="text-lg font-bold text-slate-900">{g.title}</h2>
          {g.description && <p className="text-sm text-slate-500 mb-4 mt-1">{g.description}</p>}
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
            {g.packages.map((p) => {
              const isSel = p.id === selectedId;
              let disc = 0;
              if (p.discount_type === "percent") disc = ((p.price || 0) * Math.min(Math.max(p.discount_value || 0, 0), 100)) / 100;
              else if (p.discount_type === "amount") disc = Math.min(Math.max(p.discount_value || 0, 0), p.price || 0);
              const net = Math.round((p.price - disc + Number.EPSILON) * 100) / 100;
              return (
                <button
                  key={p.id}
                  type="button"
                  disabled={locked}
                  data-testid={`public-package-${p.id}`}
                  onClick={() => !locked && selectPackage(g.id, p.id)}
                  className={`relative text-left rounded-2xl border p-5 transition-all duration-200 ${
                    isSel
                      ? "border-primary ring-2 ring-primary/30 bg-card shadow-md -translate-y-0.5"
                      : p.recommended
                      ? "border-primary/60 bg-card hover:border-primary"
                      : "border-slate-200 bg-card hover:border-slate-300"
                  } ${locked ? "cursor-default" : "cursor-pointer"}`}
                >
                  {p.recommended && (
                    <span data-testid={`public-package-${p.id}-recommended`} className="absolute -top-2.5 left-5 inline-flex items-center gap-1 bg-primary text-white text-[11px] font-bold px-2.5 py-0.5 rounded-full">
                      <Star style={{ width: 11, height: 11 }} fill="white" /> Consigliato
                    </span>
                  )}
                  <div className="flex items-start justify-between">
                    <div>
                      <p className="font-bold text-slate-900">{p.name}</p>
                      {p.subtitle && <p className="text-xs text-slate-500 mt-0.5">{p.subtitle}</p>}
                    </div>
                    <span className={`w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 ${isSel ? "border-primary bg-primary" : "border-slate-300"}`}>
                      {isSel && <span className="w-2 h-2 rounded-full bg-card" />}
                    </span>
                  </div>
                  <div className="mt-3">
                    {disc > 0 && <span className="block font-mono text-xs text-slate-400 line-through">{euro(p.price, cur)}</span>}
                    <span className="font-mono text-2xl font-extrabold text-slate-900">{euro(net, cur)}</span>
                  </div>
                  {(p.work_days || 0) > 0 && (
                    <p className="text-xs text-slate-400 mt-1 inline-flex items-center gap-1"><Clock style={{ width: 12, height: 12 }} /> Tempistica stimata: {workLabel(p.work_days, "giorni")}</p>
                  )}
                  <ul className="mt-3 space-y-1.5">
                    {(p.features || []).map((f, fi) => (
                      <li key={fi} className="flex items-start gap-2 text-sm text-slate-600">
                        <CheckCircle2 style={{ width: 15, height: 15 }} className="text-primary mt-0.5 shrink-0" /> {f}
                      </li>
                    ))}
                  </ul>
                </button>
              );
            })}
          </div>
        </div>
      );
    })}
    </>
  );
}
